export const styles = () => `.leading-custom-18 {
line-height: 1.125rem;
}
`;
